import React, { useState, useEffect } from "react";

import PlateForm from "./HomeCompontent/PlateForm";
import AboutSkill from "./HomeCompontent/AboutSkill";
import Courses from "./HomeCompontent/Courses";
import Gallery from "./HomeCompontent/Gallery";
import Navigationbar from "./HomeCompontent/Navigation";
import Testimonials from "./HomeCompontent/Testimonials";
import Mode from "./HomeCompontent/Mode";
import { useOutletContext } from "react-router-dom";
import ParticleCanvas from "./HomeCompontent/ParticleCanvas";
import UserLogin from "./User/Userlogin";
import { motion } from "framer-motion";

const Homepage = () => {
  const { darkMode, setDarkMode } = useOutletContext();
  const [showLoginOverlay, setShowLoginOverlay] = useState(false);

  useEffect(() => {
    const alreadyShown = localStorage.getItem("loginShown");

    if (!alreadyShown) {
      const timer = setTimeout(() => {
        setShowLoginOverlay(true);
        localStorage.setItem("loginShown", "true");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (showLoginOverlay) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showLoginOverlay]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div>
        <ParticleCanvas />
        <Navigationbar />
        <PlateForm />
        <AboutSkill darkMode={darkMode} />
        <Testimonials darkMode={darkMode} />
        <Courses darkMode={darkMode} />
        <Gallery darkMode={darkMode} />
        <Mode darkMode={darkMode} setDarkMode={setDarkMode} />
        {showLoginOverlay && (
          <UserLogin
            darkMode={false}
            isOverlay={true}
            onLoginSuccess={() => setShowLoginOverlay(false)}
          />
        )}
      </div>
    </motion.div>
  );
};

export default Homepage;
